import React from 'react';

import { CSSTransitionGroup } from 'react-transition-group';

import { Field } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';

import { TenantStatus } from 'components/shared/StatusHelper';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import { RenderError } from 'components/shared/RenderError';
import { browserHistory } from 'react-router';
import TenantResidentVerbiageHelper from './TenantResidentVerbiageHelper';
import { getTranslatedString } from 'helpers/i18n';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import ReactPhoneInput from 'helpers/reduxFormMaterialUiNext/ReactPhoneInput';
import { featureEnabled } from 'helpers/ToggleBot';

const styles = {
  addCotenantButton: {
    color: 'white',
  },
};

const renderCotenantTitle = (cotenant, index) => {
  if (cotenant.id) {
    return (
      <button
        type="button"
        className="link-button"
        onClick={() => browserHistory.push(`/companies/tenants?tenantId=${cotenant.id}`)}
      >
        <TenantResidentVerbiageHelper capitalize /> {index + 1} &nbsp;
      </button>
    );
  }

  return (
    <span>
      <TenantResidentVerbiageHelper capitalize /> {index + 1} &nbsp;
    </span>
  );
};

const renderIsGuarantor = (cotenant) => {
  if (!cotenant || !cotenant.is_guarantor) return null;

  return <span> (Guarantor) </span>;
};

export default ({
  fields,
  meta,
  onDelete,
  onDeleteError,
  initialFields,
  disabled,
  enableAddAndRemove,
}) => {
  if (initialFields && fields.length === 0) {
    fields.push({});
  }

  const deleteCotenant = (index) => {
    let cotenant_id = fields.get(index).id;
    if (onDelete && fields.length > 1 && cotenant_id) {
      onDelete(cotenant_id);
    } else if (onDelete === undefined || fields.length > 1) {
      fields.remove(index);
    } else {
      if (onDeleteError) onDeleteError();
    }
  };
  const shouldShowDeleteButton =
    (featureEnabled('ui.rent_roll_page.delete_residents') || enableAddAndRemove) && !disabled;
  const shouldShowAddButton =
    (featureEnabled('ui.rent_roll_page.add_residents') || enableAddAndRemove) && !disabled;

  return (
    <div className="row">
      <CSSTransitionGroup
        transitionName="add_cotenant"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {fields.map((cotenant, index) => (
          <div key={index} className="row">
            <div style={{ padding: '0 15px' }}>
              <h4 style={{ lineHeight: '26px' }}>
                {renderCotenantTitle(fields.get(index), index)}
                {renderIsGuarantor(fields.get(index))}
                <span>
                  <TenantStatus style={{ fontSize: '50%' }} tenantDetails={fields.get(index)} />
                </span>
                {shouldShowDeleteButton && (
                  <IconButton
                    style={{
                      padding: 0,
                      verticalAlign: 'text-bottom',
                      width: 'none',
                      height: 'none',
                      float: 'right',
                    }}
                    onClick={() => deleteCotenant(index)}
                  >
                    <DeleteIcon size={24} style={{ padding: 0 }} />
                  </IconButton>
                )}
              </h4>
            </div>

            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${cotenant}.first_name`}
                  component={TextField}
                  disabled={disabled}
                  type="text"
                  label={getTranslatedString('landlordPortal.cotenantsFormFields.firstName')}
                  fullWidth
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${cotenant}.last_name`}
                  component={TextField}
                  disabled={disabled}
                  type="text"
                  label={getTranslatedString('landlordPortal.cotenantsFormFields.lastName')}
                  fullWidth
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${cotenant}.email`}
                  component={TextField}
                  disabled={disabled}
                  type="email"
                  label={getTranslatedString('landlordPortal.cotenantsFormFields.email')}
                  fullWidth
                  validate={[validator.validEmail]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${cotenant}.phone_number`}
                  type="text"
                  disabled={disabled}
                  component={ReactPhoneInput}
                  label={getTranslatedString('landlordPortal.cotenantsFormFields.phoneNumber')}
                  validate={[validator.required, validator.validInternationalPhoneNumber]}
                  style={{ fontSize: '14px' }}
                />
              </div>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${cotenant}.dob`}
                  component={DatePickerAccessible}
                  disabled={disabled}
                  type="date"
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  popperPlacement="top-end"
                  label={getTranslatedString('landlordPortal.cotenantsFormFields.birthday')}
                  minDate={new Date('1920-01-01')}
                  maxDate={new Date()}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            {index !== 0 && (
              <div className="row" style={{ textAlign: 'center' }}>
                <p>{getTranslatedString('landlordPortal.cotenantsFormFields.isGuarantor')} </p>
                <BooleanRadioButtons
                  name={`${cotenant}.is_guarantor`}
                  disabled={disabled}
                  style={{ width: '120px', display: 'inline-flex' }}
                />
              </div>
            )}
          </div>
        ))}
      </CSSTransitionGroup>
      {shouldShowAddButton && (
        <div className="row" style={{ textAlign: 'center', margin: '5px 0 20px' }}>
          <FlatButton
            label={getTranslatedString('landlordPortal.cotenantsFormFields.addLeaseHolder')}
            type="button"
            backgroundColor={AccentColor()}
            hoverColor="grey"
            style={styles.addCotenantButton}
            onClick={() => {
              fields.push({});
            }}
          />

          <RenderError meta={meta} />
        </div>
      )}
    </div>
  );
};
